var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInboxAllAssigned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.205 3h8.028c.42 0 .829.12 1.18.343l.148.102 1.56 1.177c.507.382.822.961.87 1.588l.008.172-.001.805 1.918 1.77c.219.2.392.442.513.707a.728.728 0 0 1 .181.652l.012.13.004.13v1.736a.735.735 0 0 1-1.463.1l-.007-.1V10.9h-2.94a.735.735 0 0 1-.727-.634l-.007-.1v-2.94H9.42a.735.735 0 0 0-.729.636l-.006.1v10.81c0 .372.275.68.633.729l.1.007 9.003.023c.373 0 .68-.276.729-.635l.006-.1v-.243a.735.735 0 0 1 1.463-.1l.007.1v.243a2.205 2.205 0 0 1-2.047 2.2L18.42 21h-.005l-9.002-.024a2.205 2.205 0 0 1-2.164-1.81H6.205a2.205 2.205 0 0 1-2.2-2.046L4 16.962V5.205c0-1.165.903-2.119 2.047-2.2L6.205 3h8.028zm10.098 9.002a.34.34 0 0 1 .213.076l4.14 3.268c.165.13.203.384.085.566a.389.389 0 0 1-.085.094l-4.14 3.269a.345.345 0 0 1-.512-.094.435.435 0 0 1-.068-.236v-1.747H11.99c-.203 0-.367-.182-.367-.406V14.56c0-.225.164-.406.367-.406h3.945v-1.747c0-.224.164-.406.367-.406zm-2.07-7.532H6.205a.735.735 0 0 0-.729.635l-.006.1v11.757c0 .372.276.68.635.728l.1.007h1.009l.001-9.737c0-1.164.903-2.118 2.047-2.199l.158-.005h6.165c.26 0 .514.045.754.133l-.017-.018-.085-.076-1.561-1.177a.735.735 0 0 0-.21-.11l-.114-.029-.119-.01zm2.718 3.751V9.43l1.31-.001-1.31-1.208z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxAllAssigned);
export default __webpack_public_path__ + "static/media/ic-inbox-all-assigned.13be4bba4a6e4c0c588bef3824cf0fec.svg";
export { ForwardRef as ReactComponent };